module.exports = __webpack_public_path__ + "img/nina-varela.35a80166.png";